export default __webpack_public_path__ + "static/media/01.21190d42.jpg";